import { render, staticRenderFns } from "./packageForComponent.vue?vue&type=template&id=030894be&scoped=true"
import script from "./packageForComponent.vue?vue&type=script&lang=js"
export * from "./packageForComponent.vue?vue&type=script&lang=js"
import style0 from "./packageForComponent.vue?vue&type=style&index=0&id=030894be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030894be",
  null
  
)

export default component.exports